export default __webpack_public_path__ + "static/media/harryjmg.a3da1c9d.webp";